import { DateFormatPreset } from '@procureai/ui-mui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CaclCountryReportListItem } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import {
  DataGridConfig,
  NULLISH_CELL_VALUE,
  UseDataGridConfig,
  cellFactory,
  gridColDefFactory,
} from '~/components/DataGridCustom';
import { DateCellFactory } from '~/components/ResponsiveTable';

export const useCountryReportListGridConfig: UseDataGridConfig<CaclCountryReportListItem> = () => {
  const { t } = useTranslation(I18nNamespace.riskSustainability);
  const { t: tColumn } = useTranslation(I18nNamespace.riskSustainability, {
    keyPrefix: 'CountryReportListGrid.column',
  });

  return useMemo(() => {
    const createColumn = gridColDefFactory({ tColumn, t });
    return {
      columns: [
        createColumn({
          field: 'name',
          minWidth: 350,
        }),
        createColumn({
          field: 'description',
          minWidth: 500,
        }),
        createColumn({
          field: 'publishedAt',
          minWidth: 150,
          renderCell: cellFactory(
            DateCellFactory({ preset: DateFormatPreset.TWO_DIGIT, fallback: NULLISH_CELL_VALUE }),
          ),
        }),
      ],
    } as DataGridConfig<CaclCountryReportListItem>;
  }, [t, tColumn]);
};
